import ContactDirectory from "@/components/ContactDirectory";

export default function CoPackers({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Co-Packers"
      subtitle="Contract filling partners who receive your components and produce finished goods."
      endpoint="/co-packers"
      prefix="copacker"
      singular="co-packer"
      addLabel="Add co-packer"
    />
  );
}
